// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"6dde13e7","453":"678dcf00","930":"1c00bf7e"}[chunkId] + ".chunk.js";
};